import React from "react";
import "./Campaign.scss";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const CNY88 = () => {
  return (
    <>
      <Navbar />

      <div className="privacy-and-terms">
        <div className="container">

          {/* HEADER */}
          <div className="header-title giftaway-header">
            <div className="overlay">
              <h2>Teleport Now CNY Giftaway Campaign Terms & Conditions</h2>
            </div>
          </div>

          {/* CONTENT */}
          <div className="page-content">

            <div className="term-heading">
              <h4>Giftaway Campaign Terms & Conditions</h4>
              <p>
                Campaign Period:{" "}
                <span>15 February 2026 – 22 February 2026 (SGT)</span>
              </p>
            </div>

            <div className="point-wrap">

              {/* ORGANISER */}
              <h2>1. Organiser</h2>
              <p>
                The Teleport Now Giftaway Campaign (“Campaign”) is organised by{" "}
                <b>TELEPORT NOW (SG) PTE. LTD.</b> (“Teleport Now”, “Organiser”,
                “we”, “our”, or “us”), a company incorporated in Singapore.
              </p>

              <hr />

              {/* CAMPAIGN PERIOD */}
              <h2>2. Campaign Period</h2>
              <p>
                The Campaign will run from <b>15 February 2026, 08:00 PM (SGT)</b>{" "}
                to <b>22 February 2026, 11:59 PM (SGT)</b>. Entries received outside
                this period will not be considered.
              </p>

              <hr />

              {/* ELIGIBILITY */}
              <h2>3. Eligibility</h2>
              <ul>
                <li>
                  Open only to residents of Singapore aged 18 years and above.
                </li>

                <li>
                  Employees of Teleport Now and their immediate family members
                  are not eligible.
                </li>

                <li>
                  Participants must have a valid TikTok or Instagram account set to public
                  during the Campaign Period.
                </li>

                <li>
                  Winners must have a valid Teleport Now account to receive the
                  Prize. If the winner does not have an account, they must sign
                  up and create one before the Prize can be credited.
                </li>
              </ul>

              <hr />

              {/* PARTICIPATION */}
              <h2>4. How to Participate</h2>

              <p>
                To qualify for the Campaign, participants must complete ALL of
                the following steps:
              </p>

              <ul>
                <li>Follow @TeleportNowSG on TikTok or @Teleport_Now on Instagram</li>

                <li>Like the designated giveaway content</li>

                <li>Share the giveaway post</li>

                <li>Tag loved ones in the comments section</li>
              </ul>

              <p>
                Incomplete, fraudulent, or invalid entries may be disqualified
                at the Organiser’s sole discretion.
              </p>

              <hr />

              {/* PRIZE */}
              <h2>5. Prize</h2>

              <ul>
                <li>
                  Five (5) winners will each receive{" "}
                  <b>USD $88 worth of Telly Credits</b>.
                </li>

                <li>
                  Telly Credits will be credited directly into the winner’s
                  Teleport Now account.
                </li>

                <li>
                  Credits are valid exclusively for use within the Teleport Now
                  platform.
                </li>

                <li>
                  Credits expire <b>180 days</b> from the date of issuance.
                </li>

                <li>
                  Credits are non-transferable, non-exchangeable, and
                  non-redeemable for cash.
                </li>

                <li>
                  Any costs exceeding the credit value shall be borne solely by
                  the winner.
                </li>
              </ul>

              <hr />

              {/* WINNER SELECTION */}
              <h2>6. Winner Selection and Announcement</h2>

              <ul>
                <li>
                  Five (5) winners will be selected at random from all eligible
                  entries.
                </li>

                <li>
                  Winners will be contacted by{" "}
                  <b>25 February 2026, 11:59 PM (SGT)</b>.
                </li>

                <li>
                  Winners will be contacted via TikTok/Instagram Direct Message or Email.
                </li>

                <li>
                  Winners must respond and create a Teleport Now account (if
                  required) within 24 hours, failing which the Prize may be
                  forfeited and an alternative winner selected.
                </li>
              </ul>

              <hr />

              {/* VERIFICATION */}
              <h2>7. Verification</h2>

              <p>
                Teleport Now reserves the right to verify participant identity,
                TikTok/Instagram account ownership, and Teleport Now account validity.
                False, misleading, or incomplete information may result in
                disqualification.
              </p>

              <hr />

              {/* PUBLICITY */}
              <h2>8. Publicity and Consent</h2>

              <p>
                By participating in the Campaign, participants grant Teleport Now
                the right to use their name, TikTok/Instagram handle, likeness, and/or
                submitted content for publicity, promotional, and marketing
                purposes without further notice or compensation, unless
                prohibited by law.
              </p>

              <hr />

              {/* LIABILITY */}
              <h2>9. Limitation of Liability</h2>

              <p>
                To the fullest extent permitted by law, Teleport Now shall not be
                liable for any loss, damage, injury, or disappointment suffered
                by any participant arising from participation in the Campaign or
                use of the Prize.
              </p>

              <hr />

              {/* DISCLAIMER */}
              <h2>10. TikTok/Instagram Disclaimer</h2>

              <p>
                This Campaign is not sponsored, endorsed, administered by, or
                associated with TikTok/Instagram.
              </p>

              <hr />

              {/* ORGANISER RIGHTS */}
              <h2>11. Organiser Rights</h2>

              <ul>
                <li>
                  Disqualify participants who breach these Terms and Conditions
                </li>

                <li>
                  Amend, suspend, extend, or cancel the Campaign at any time
                </li>

                <li>
                  Refuse prize issuance if Teleport Now account requirements are
                  not fulfilled
                </li>
              </ul>

              <hr />

              {/* GOVERNING LAW */}
              <h2>12. Governing Law</h2>

              <p>
                These Terms and Conditions shall be governed by and interpreted
                in accordance with the laws of Singapore.
              </p>

              <hr />

              {/* CONTACT */}
              <h2>Contact Information</h2>

              <p>
                TELEPORT NOW (SG) PTE. LTD. <br />
                Email: support@teleportapp.sg
              </p>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CNY88;
